module.exports = __webpack_public_path__ + "img/contactbg.c2eeb76a.jpg";